import script from "./category.vue?vue&type=script&setup=true&name=QualificationApply&lang=js"
export * from "./category.vue?vue&type=script&setup=true&name=QualificationApply&lang=js"

import "./category.vue?vue&type=style&index=0&id=abcd34a8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abcd34a8"]])

export default __exports__